import { render, staticRenderFns } from "./SurveyBanner.vue?vue&type=template&id=4b724182&scoped=true&"
import script from "./SurveyBanner.vue?vue&type=script&lang=js&"
export * from "./SurveyBanner.vue?vue&type=script&lang=js&"
import style0 from "./SurveyBanner.vue?vue&type=style&index=0&id=4b724182&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b724182",
  null
  
)

export default component.exports